module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00187.c350ade0.jpg";